import { render } from "./BilancioPrevisionale.vue?vue&type=template&id=7a6e607f&ts=true"
import script from "./BilancioPrevisionale.vue?vue&type=script&lang=ts"
export * from "./BilancioPrevisionale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__